import { Container, Modal, Row } from "react-bootstrap";
import { connect } from "react-redux";


function ComingSoon({ show, handleClose }) {
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Body>
        <Container>
          <Row className="align-items-center justify-content-center">
            <p
              role="button"
              className="shadow p-2 bg-white rounded-circle"
              onClick={handleClose}
              style={{
                background: "#F5F5F5",
                position: "absolute",
                right: 10,
                top: 10,
              }}
            >
              <img src="/assets/close.svg" alt="close"/>
            </p>
            <img src="/assets/work-in-progress.webp" height="200px" className="p-4"  alt="progress"/>
            <div className="ml-md-5">
              <h1>Will be Live Soon</h1>
              <p className="text-dark">
                We are working to bring you a great experience.
              </p>
            </div>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    loginData: state.loginData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ComingSoon);
